// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import classnames from '@ta/common.classnames';
import { ModalView } from '@ta/overlays.modal';
import { TitleBar } from '@ta/modal.headers';
import TripModalCloseX from './TripModalCloseX';
import styles from './TripModalViewLayout.less';

type ExternalProps = {|
  /** The title for the modal header on MW. If the title renders nothing, then the header is suppressed */
  title: React.Node,
  /** An optional callback that's fired in the event the modal closes */
  onClose?: () => mixed,
  /** Children to render within the contents */
  children: React.Node,
|};

type Props = {|
  ...ExternalProps,
  isIE11: boolean,
  isMobile: boolean,
|};

/** Opinionated modal styling of a trip modal view */
const TripModalViewLayout = ({ isMobile, isIE11, title, onClose, children }: Props) => (
  <ModalView
    onClose={onClose}
    roundedCorners
    isFullBleed
    header={isMobile && title && <TitleBar displayType="LEFT_ALIGN_GREEN">{title}</TitleBar>}
    closeX={!!(isMobile && title)}
    closeXColorVariant="WHITE"
    unconstrainedHeight
  >
    <div className={styles.trip_content}>
      {!isMobile && (
        <TripModalCloseX
          className={classnames(styles.closeX, { [styles.IE11]: isIE11 })}
          onClick={onClose}
        />
      )}
      {children}
    </div>
  </ModalView>
);

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  isMobile: state.meta.device.viewportCategory === 'MOBILE',
  isIE11:
    state.meta.device.browser.family === 'IE' && state.meta.device.browser.majorVersion === 11,
}))(TripModalViewLayout);
